/** LeafLink order statuses that end the order on LeafLink's side. */
export const LEAFLINK_NO_LONGER_OPEN_STATUSES = ['Cancelled', 'Rejected'];
//# sourceMappingURL=leaflink-no-longer-open-statuses.js.map